<template>

    <div class="menulist-wrapper">
        <div class="menulist-header">
            <h3>{{ lang('all.winkelwagen') }}</h3>
            <div>
                <a
                    href="#"
                    @click.prevent="closeMinicart"
                >
                    <i class="mdi mdi-close-box-outline"></i>
                    <span class="sr-only">{{ lang('all.minicart_sluiten') }}</span>
                </a>
            </div>
        </div>
        <div
            :class="{'menulist-content':true, 'auth':isAuthenticated}"
        >
            <div
                v-if="products.length === 0"
                class="menulist-product mb-4"
            >
                <p>{{ lang('all.er_zijn_nog_geen_producten_in_de_winkelwagen_gepla') }}</p>
            </div>
            <div
                v-for="product in products"
                class="menulist-product"
            >
                <div class="row">
                    <div class="col-4">
                        <inertia-link
                            :href="route('products.item', {brand_slug:product.product.brand_slug, slug:product.product.slug})"
                            @click="closeMinicart"
                        >
                            <img
                                :src="product.product.image.url"
                                :alt="product.product.image.name"
                                class="thumbnail"
                            />
                        </inertia-link>
                    </div>
                    <div class="col-8">
                        <div class="menulist-product-details">
                            <h4>
                                <inertia-link
                                    :href="route('products.item', {brand_slug:product.product.brand_slug, slug:product.product.slug})"
                                    @click="closeMinicart"
                                >
                                    {{ product.product.name }}
                                </inertia-link>
                            </h4>

                            <p v-if="isAuthenticated">{{ product.quantity }}x &aacute; {{ product.product.price | toCurrency }}</p>
                            <p v-else>{{ product.quantity }}x</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="isAuthenticated && products.length > 0"
            class="menulist-subtotal"
        >
            <div class="row">
                <div class="col-6">
                    {{ lang('all.subtotaal2') }}
                </div>
                <div class="col-6 text-right">
                    {{ cart.subtotal | toCurrency }}
                </div>
            </div>
        </div>
        <div
            v-if="products.length > 0"
            class="menulist-footer"
        >
            <inertia-link
                class="btn btn-primary"
                :href="route('cart.index')"
                @click="closeMinicart"
            >
                {{ lang('all.winkelwagen_bekijken') }}
            </inertia-link>
            <inertia-link
                class="btn btn-secondary"
                :href="route('auth.checkout.index')"
                @click="closeMinicart"
            >
                {{ lang('all.afrekenen') }}
            </inertia-link>
        </div>
    </div>

</template>

<script>

import BaseCart from "./BaseCart";

export default {

    extends: BaseCart,

    methods: {
        closeMinicart() {
            this.$emit('closeMinicart');
        },
    },

    name:'ShopHeaderMinicart',

}

</script>
